import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  GetProdutcsResult,
  Loading,
  Product,
  ProductsRepository,
  Sort,
} from "../domain";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type ProductsState = {
  loading: Loading;
  products: Product[];
  productsCount: number;
  pageSize: number;
};

const initialState: ProductsState = {
  loading: "idle",
  products: [],
  pageSize: 0,
  productsCount: 0,
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    productsLoading(state) {
      state.loading = "pending";
    },
    productsLoaded(state, { payload }: PayloadAction<GetProdutcsResult>) {
      const { pageSize, productsCount, products } = payload;
      state.pageSize = pageSize;
      state.productsCount = productsCount;
      state.products = products;
      state.loading = "succeeded";
    },
    productsFailed(state) {
      state.loading = "failed";
    },
  },
});

export default productsSlice.reducer;

const {
  productsFailed,
  productsLoaded,
  productsLoading,
} = productsSlice.actions;

export const loadProducts = (page: number, sort: Sort): AppThunk => async (
  dispatch
) => {
  dispatch(productsLoading());
  const res = await ServiceLocater.get<ProductsRepository>(
    Services.ProductsRepository
  ).getProducts(page, sort);
  res.fold(
    (_) => {
      dispatch(productsFailed());
    },
    (r) => {
      dispatch(productsLoaded(r));
    }
  );
};
